import { render, staticRenderFns } from "./ContactInformationMainContact.vue?vue&type=template&id=e1038f00&scoped=true&"
import script from "./ContactInformationMainContact.vue?vue&type=script&lang=ts&"
export * from "./ContactInformationMainContact.vue?vue&type=script&lang=ts&"
import style0 from "./ContactInformationMainContact.vue?vue&type=style&index=0&id=e1038f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1038f00",
  null
  
)

export default component.exports